import { normCdf } from "./bs";

/** Payoff at expiry per option, in the same unit as spot and strike. */
export function payoff(isCall: boolean, spot: number, strike: number): number {
  return isCall ? Math.max(0, spot - strike) : Math.max(0, strike - spot);
}

/** Price at which buying the option breaks even (premium per option included). */
export function breakeven(isCall: boolean, strike: number, premiumPerOption: number): number {
  return isCall ? strike + premiumPerOption : Math.max(0, strike - premiumPerOption);
}

/** Buckets series by expiry, sorted. */
export function byExpiry<T extends { expiry: number }>(rows: T[]): Map<number, T[]> {
  const m = new Map<number, T[]>();
  for (const r of [...rows].sort((a, b) => a.expiry - b.expiry)) {
    const list = m.get(r.expiry) ?? [];
    list.push(r);
    m.set(r.expiry, list);
  }
  return m;
}

/** Model probability that an option finishes in the money (risk-neutral N(d2)), from the chain's vol. */
export function probItm(s: { isCall: boolean; strikeEth: number; expiry: number }, spot: number, sigma: number): number {
  const t = Math.max(60, s.expiry - Date.now() / 1000) / (365 * 86_400);
  const vt = sigma * Math.sqrt(t);
  const d2 = (Math.log(spot / s.strikeEth) - (vt * vt) / 2) / vt;
  return s.isCall ? normCdf(d2) : normCdf(-d2);
}

export const fmtProb = (p: number) => (p < 0.005 ? "<1%" : p > 0.995 ? ">99%" : `${Math.round(p * 100)}%`);

/** Monthly = the month's last Friday, weekly = any other Friday, daily = the rest. */
export function expiryKind(ts: number): "daily" | "weekly" | "monthly" {
  const d = new Date(ts * 1000);
  if (d.getUTCDay() !== 5) return "daily";
  return new Date(ts * 1000 + 7 * 86_400_000).getUTCMonth() !== d.getUTCMonth() ? "monthly" : "weekly";
}

export const shortDate = (ts: number) => new Date(ts * 1000).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
